// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"288":"controleprodutos","832":"etiquetaprodutos"}[chunkId] || chunkId) + ".js";
};